import { useQueryParamHelper } from '@shared/core/queryString';
import { CardFormat } from '../../../ProductDetailsPage/constants';

// Basic digital is not included. `premiumDigital` intentended to cover both.
export type CardFormatWithAll = CardFormat.premiumDigital | CardFormat.paper | 'all' | undefined;

export const FORMAT_SEARCH_PARAM_KEY = 'format';

export function toFormatList(format: CardFormatWithAll): CardFormat[] {
  if (!format || format === 'all') return [CardFormat.premiumDigital, CardFormat.paper];
  return [format];
}

/**
 * The `?format=` param only steers which product prices the tiles show (and is what the
 * gallery nav's deep links set alongside their `pf` facet). It is not a filter: toggling the
 * Free pill or a Digital option writes it as a side effect of that `pf` selection
 * (`useToggleFilter`).
 */
export function useFormatSearchParam() {
  const queryParams = useQueryParamHelper();
  const format = queryParams.getValueString(FORMAT_SEARCH_PARAM_KEY) as CardFormatWithAll;
  return [format] as const;
}
